import { Component, OnInit, ViewChild } from "@angular/core";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { MasterService } from "../../Shared/app.Masters.Service";
import { RequestModel } from "../../Shared/Models/app.MasterRequestModel";
import { SnackbarComponent } from "../../snackbar/snackbar.component";

@Component({
  selector: "app-creditpolicy",
  templateUrl: "./creditpolicy.component.html",
  styleUrls: ["./creditpolicy.component.scss"],
})
export class CreditpolicyComponent implements OnInit {
  private data: any;
  private _MasterService;
  showSpinner: boolean = false;
  dataSource: any;
  loading: boolean = false;
  displayedColumns: string[] = ["ChagesHeadID", "ChagesHead", "EditAction"];
  RequestModel: RequestModel = new RequestModel();
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  policydata: any = [];
  Policy: any = "Manual";
  UpdatedOn: any = "";
  LastUpdatedBy: any = "";
  inViewMode: boolean = true;
  LoanProductList: any = [];
  LoanBranchList: any = [];
  EmployeeAndAmount: any = [];
  GetEmployeeDropdown: any = [];
  GetRecomm_EmpIdDropdown: any = [];
  employeeDropdownSettingsB = {
  singleSelection: false,
  idField: 'EmpId',
  textField: 'EmpName',
  selectAllText: 'Select All',
  unSelectAllText: 'Unselect All',
  allowSearchFilter: true,
  itemsShowLimit: 3
};
employeeDropdownSettingsP = {
  singleSelection: false,
  idField: 'EmpId',
  textField: 'EmpName',
  selectAllText: 'Select All',
  unSelectAllText: 'Unselect All',
  allowSearchFilter: true,
  itemsShowLimit: 3
};

  constructor(
    private dataSharingService: DataSharingService,
    public snackBar: MatSnackBar,
    private MasterService: MasterService
  ) {
    this._MasterService = MasterService;
    this.data = JSON.parse(sessionStorage.getItem("currentUser"));
  }

  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };

  ngOnInit() {
    this.dataSharingService.HeaderTitle.next("Credit Assignment Policy");

    this._MasterService
      .QuickLoan_Employee_Assignment_Dropdown({ ProcessId: 2, BranchId: 0 })
      .subscribe((res: any) => {
        this.GetEmployeeDropdown = res;
      });
    this._MasterService
      .QuickLoan_Employee_Assignment_Dropdown({ ProcessId: 20, BranchId: 0 })
      .subscribe((res: any) => {
        this.GetRecomm_EmpIdDropdown = res;
      });
    this.getcreditAssignmentpolicy(false);
  }

  getcreditAssignmentpolicy(changepolicy) {
    this.showSpinner = true;
    this._MasterService.LOS_GetCreditAssignmentPolicy().subscribe((result) => {
      this.policydata = JSON.parse(JSON.stringify(result));

      if (this.policydata.Item1) {
        if (changepolicy == false)
          this.Policy = this.policydata.Item1[0].CurrentPolicy;
        this.UpdatedOn = this.policydata.Item1[0].LastUpdatedOn;
        this.LastUpdatedBy = this.policydata.Item1[0].LastUpdatedBy;
        this.LoanProductList = this.policydata.Item2;
        // this.LoanProductList.forEach((obj: any) => {

        //   // Convert "1,3,5" → [{EmpId:1,EmpName:''}, ...]
        //   if (obj.EmpIds) {
        //     const ids = obj.EmpIds.split(',');
        //     obj.EmpIds = obj.GetEmployeeDropdown.filter(x =>
        //       ids.includes(x.EmpId.toString())
        //     );
        //   } else {
        //     obj.EmpIds = [];
        //   }

        //   if (obj.Recomm_EmpIds) {
        //     const ids = obj.Recomm_EmpIds.split(',');
        //     obj.Recomm_EmpIds = obj.GetRecomm_EmpIdDropdown.filter(x =>
        //       ids.includes(x.EmpId.toString())
        //     );
        //   } else {
        //     obj.Recomm_EmpIds = [];
        //   }

        // });

        this.LoanBranchList = this.policydata.Item4;
      //    this.LoanBranchList.forEach((obj: any) => {

      //   // Convert "1,3,5" → [{EmpId:1,EmpName:''}, ...]
      //   if (obj.EmpIds) {
      //     const ids = obj.EmpIds.split(',');
      //     obj.EmpIds = obj.GetEmployeeDropdown.filter(x =>
      //       ids.includes(x.EmpId.toString())
      //     );
      //   } else {
      //     obj.EmpIds = [];
      //   }

      //   if (obj.Recomm_EmpIds) {
      //     const ids = obj.Recomm_EmpIds.split(',');
      //     obj.Recomm_EmpIds = obj.GetRecomm_EmpIdDropdown.filter(x =>
      //       ids.includes(x.EmpId.toString())
      //     );
      //   } else {
      //     obj.Recomm_EmpIds = [];
      //   }

      // });

        this.EmployeeAndAmount =
          this.policydata.Item3.length > 0
            ? this.policydata.Item3
            : [{ EmpId: "", Recomm_EmpId: "", FromAmount: 1, ToAmount: "" }];

        this.inViewMode = true;
        this.showSpinner = false;
        if (this.Policy == "Product") {
          // this.LoanProductList.forEach((obj: any) => {
          //   this._MasterService
          //     .Employee_Dropdown_For_Product_OR_Branch({
          //       ProcessId: 2,
          //       BranchId: 0,
          //       ProductId: obj.ProductId,
          //     })
          //     .subscribe((res: any) => {
          //       obj.GetEmployeeDropdown = res;
          //     });
          //   this._MasterService
          //     .Employee_Dropdown_For_Product_OR_Branch({
          //       ProcessId: 20,
          //       BranchId: 0,
          //       ProductId: obj.ProductId,
          //     })
          //     .subscribe((res: any) => {
          //       obj.GetRecomm_EmpIdDropdown = res;
          //     });
          // });
        this.LoanProductList.forEach((obj: any) => {
        this._MasterService
          .Employee_Dropdown_For_Product_OR_Branch({
            ProcessId: 2,
            BranchId: 0,
            ProductId: obj.ProductId,
          })
          .subscribe((res: any) => {

            obj.GetEmployeeDropdown = res;

            // Convert EmpIds AFTER dropdown is available
            // if (obj.EmpIds) {
            //   const ids = obj.EmpIds.split(',');
            //   obj.EmpIds = res.filter(x =>
            //     ids.includes(x.EmpId.toString())
            //   );
            // } else {
            //   obj.EmpIds = [];
            // }
            let empIdsString = obj.EmpIds || obj.EmpId?.toString();

            if (empIdsString) {
              const ids = empIdsString.split(',');
              obj.EmpIds = res.filter(x =>
                ids.includes(x.EmpId.toString())
              );
            } else {
              obj.EmpIds = [];
            }

          });

        this._MasterService
          .Employee_Dropdown_For_Product_OR_Branch({
            ProcessId: 20,
            BranchId: 0,
            ProductId: obj.ProductId,
          })
          .subscribe((res: any) => {

            obj.GetRecomm_EmpIdDropdown = res;

            // if (obj.Recomm_EmpIds) {
            //   const ids = obj.Recomm_EmpIds.split(',');
            //   obj.Recomm_EmpIds = res.filter(x =>
            //     ids.includes(x.EmpId.toString())
            //   );
            // } else {
            //   obj.Recomm_EmpIds = [];
            // }
            let recommIdsString = obj.Recomm_EmpIds || obj.Recomm_EmpId?.toString();

            if (recommIdsString) {
              const ids = recommIdsString.split(',');
              obj.Recomm_EmpIds = res.filter(x =>
                ids.includes(x.EmpId.toString())
              );
            } else {
              obj.Recomm_EmpIds = [];
            }

          });

      });
        }
        if (this.Policy == "Branch") {
          // this.LoanBranchList.forEach((obj: any) => {
          //   this._MasterService
          //     .Employee_Dropdown_For_Product_OR_Branch({
          //       ProcessId: 2,
          //       BranchId: obj.BranchId,
          //       ProductId: 0,
          //     })
          //     .subscribe((res: any) => {
          //       obj.GetEmployeeDropdown = res;
          //     });
          //   this._MasterService
          //     .Employee_Dropdown_For_Product_OR_Branch({
          //       ProcessId: 20,
          //       BranchId: obj.BranchId,
          //       ProductId: 0,
          //     })
          //     .subscribe((res: any) => {
          //       obj.GetRecomm_EmpIdDropdown = res;
          //     });
          // });
        this.LoanBranchList.forEach((obj: any) => {
        this._MasterService
          .Employee_Dropdown_For_Product_OR_Branch({
            ProcessId: 2,
            BranchId: obj.BranchId,
            ProductId: 0,
          })
          .subscribe((res: any) => {

            obj.GetEmployeeDropdown = res;

            // Convert EmpIds AFTER dropdown is available
            // if (obj.EmpIds) {
            //   const ids = obj.EmpIds.split(',');
            //   obj.EmpIds = res.filter(x =>
            //     ids.includes(x.EmpId.toString())
            //   );
            // } else {
            //   obj.EmpIds = [];
            // }
            let empIdsString = obj.EmpIds || obj.EmpId?.toString();

            if (empIdsString) {
              const ids = empIdsString.split(',');
              obj.EmpIds = res.filter(x =>
                ids.includes(x.EmpId.toString())
              );
            } else {
              obj.EmpIds = [];
            }

          });

        this._MasterService
          .Employee_Dropdown_For_Product_OR_Branch({
            ProcessId: 20,
            BranchId: obj.BranchId,
            ProductId: 0,
          })
          .subscribe((res: any) => {

            obj.GetRecomm_EmpIdDropdown = res;

            // if (obj.Recomm_EmpIds) {
            //   const ids = obj.Recomm_EmpIds.split(',');
            //   obj.Recomm_EmpIds = res.filter(x =>
            //     ids.includes(x.EmpId.toString())
            //   );
            // } else {
            //   obj.Recomm_EmpIds = [];
            // }

            // let recommIdsString = obj.Recomm_EmpIds || obj.Recomm_EmpId?.toString();

            // if (recommIdsString) {
            //   const ids = recommIdsString.split(',');
            //   obj.Recomm_EmpIds = res.filter(x =>
            //     ids.includes(x.EmpId.toString())
            //   );
            // } else {
            //   obj.Recomm_EmpIds = [];
            // }

            let recommIdsString = obj.Recomm_EmpIds || obj.Recomm_EmpId?.toString();

if (recommIdsString) {
  const ids = recommIdsString.split(',');
  obj.Recomm_EmpIds = res.filter(x =>
    ids.includes(x.EmpId.toString())
  );
} else {
  obj.Recomm_EmpIds = [];
}

          });

      });
        }
      }
    });
  }

  OnEditCurrentPolicy() {
    this.inViewMode = false;
  }

  onAddNewAmount() {
    let employeeId =
      this.EmployeeAndAmount[this.EmployeeAndAmount.length - 1].EmpId;
    let Recomm_EmpId =
      this.EmployeeAndAmount[this.EmployeeAndAmount.length - 1].Recomm_EmpId;

    if (
      employeeId == "" ||
      employeeId == 0 ||
      employeeId == "0" ||
      employeeId == null
    ) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Please Select Employee.",
        ...this.configSuccess,
      });
      return;
    }
    if (
      Recomm_EmpId == "" ||
      Recomm_EmpId == 0 ||
      Recomm_EmpId == "0" ||
      Recomm_EmpId == null
    ) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Please Select Credit Recommendation Employee.",
        ...this.configSuccess,
      });
      return;
    }
    if (
      this.EmployeeAndAmount[this.EmployeeAndAmount.length - 1].ToAmount == ""
    ) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Please Enter To Amount.",
        ...this.configSuccess,
      });
      return;
    }
    this.EmployeeAndAmount.push({
      EmpId: "",
      Recomm_EmpId: "",
      FromAmount:
        parseFloat(
          this.EmployeeAndAmount[this.EmployeeAndAmount.length - 1].ToAmount
        ) + 1,
      ToAmount: "",
    });
  }

  onDeleteAmount(index) {
    this.EmployeeAndAmount.splice(index, 1);
  }
  onChange(event: any, data: any) {
    let _v = event.target.value;
    let _count = 0;
    this.EmployeeAndAmount.forEach((obj: any) => {
      if (obj.EmpId == _v) {
        _count = _count + 1;
      }
    });
    // if (_count > 1) {
    //   this.snackBar.openFromComponent(SnackbarComponent, {
    //     data: "employee already selected please choose another employee",
    //     ...this.configSuccess,
    //   });
    //   event.target.value = "";
    //   data.EmpId = "";
    //   return false;
    // }
  }
  onChangeRecomm_EmpId(event: any, data: any) {
    let _v = event.target.value;
    let _Recomm_EmpIdcount = 0;
    this.EmployeeAndAmount.forEach((obj: any) => {
      if (obj.Recomm_EmpId == _v) {
        _Recomm_EmpIdcount = _Recomm_EmpIdcount + 1;
      }
    });
    // if (_Recomm_EmpIdcount > 1) {
    //   this.snackBar.openFromComponent(SnackbarComponent, {
    //     data: "employee already selected please choose another employee",
    //     ...this.configSuccess,
    //   });
    //   event.target.value = "";
    //   data.Recomm_EmpId = "";
    //   return false;
    // }
  }
  onSubmitData() {
    console.log("submit started");
    var EmpID = 0;
    // let usedEmployees: any[] = [];
    if (this.EmployeeAndAmount.length > 1) {
      this.EmployeeAndAmount.map((item) => {
        EmpID = item.EmpId;

        // if (item.EmpId == "") {
        //   this.snackBar.openFromComponent(SnackbarComponent, {
        //     data: "Please select employee.",
        //     ...this.configSuccess,
        //   });
        //   return;
        // } else 
          if (item.Recomm_EmpId == "") {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "Please select Recomm_EmpId.",
            ...this.configSuccess,
          });
          return;
        } else if (item.ToAmount == "") {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "ToAmount not accept blank.",
            ...this.configSuccess,
          });
          return;
        }
        if (item.FromAmount >= item.ToAmount) {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "Please enter correct Toamount.",
            ...this.configSuccess,
          });
          return;
        }
        // if (item.EmpId == EmpID) {
        //   this.snackBar.openFromComponent(SnackbarComponent, {
        //     data: "Please Choose another Employee.",
        //     ...this.configSuccess,
        //   });
        //   return;
        // }
      });
    }
    let amountData = [];
    if (
      this.EmployeeAndAmount[this.EmployeeAndAmount.length - 1].EmpId != "" &&
      this.EmployeeAndAmount[this.EmployeeAndAmount.length - 1].ToAmount != ""
    ) {
      this.EmployeeAndAmount.map((item) => {
        amountData.push({
          EmployeeId: item.EmpId,
          Recomm_EmpId: item.Recomm_EmpId,
          FromAmount: item.FromAmount,
          ToAmount: item.ToAmount,
        });
      });
    }
    // let productData = [];
    // this.LoanProductList.map((item) => {
    //   productData.push({
    //     ProductId: item.ProductId,
    //     EmployeeId: item.EmpId,
    //     Recomm_EmpId: item.Recomm_EmpId,
    //   });
    // });
//     let productData = [];
// this.LoanProductList.map((item) => {
//   productData.push({
//     ProductId: item.ProductId,
//     EmpIds: item.EmpIds ? item.EmpIds.join(',') : '',
//     Recomm_EmpIds: item.Recomm_EmpIds ? item.Recomm_EmpIds.join(',') : ''
//   });
// });
      let productData = [];

      this.LoanProductList.forEach((item) => {

        // const empIds = item.EmpIds?.map(x => x.EmpId).join(',') || '';
        // const recommIds = item.Recomm_EmpIds?.map(x => x.EmpId).join(',') || '';
    //         const empIds = item.EmpIds && item.EmpIds.length > 0
    //   ? item.EmpIds.map(x => x.EmpId).join(',')
    //   : null;

    // const recommIds = item.Recomm_EmpIds && item.Recomm_EmpIds.length > 0
    //   ? item.Recomm_EmpIds.map(x => x.EmpId).join(',')
    //   : null;
    const empIds = Array.isArray(item.EmpIds)
  ? item.EmpIds.map(x => x.EmpId).join(',')
  : null;

const recommIds = Array.isArray(item.Recomm_EmpIds)
  ? item.Recomm_EmpIds.map(x => x.EmpId).join(',')
  : null;

            productData.push({
              ProductId: item.ProductId,
              EmpIds: empIds,
              Recomm_EmpIds: recommIds
            });

      });

    // let BranchData = [];
    // this.LoanBranchList.map((item) => {
    //   BranchData.push({
    //     BranchId: item.BranchId,
    //     EmployeeId: item.EmpId,
    //     Recomm_EmpId: item.Recomm_EmpId,
    //   });
    // });
    let BranchData = [];

      this.LoanBranchList.forEach((item) => {

        // const empIds = item.EmpIds?.map(x => x.EmpId).join(',') || '';
        // const recommIds = item.Recomm_EmpIds?.map(x => x.EmpId).join(',') || '';
    //         const empIds = item.EmpIds && item.EmpIds.length > 0
    //   ? item.EmpIds.map(x => x.EmpId).join(',')
    //   : null;

    // const recommIds = item.Recomm_EmpIds && item.Recomm_EmpIds.length > 0
    //   ? item.Recomm_EmpIds.map(x => x.EmpId).join(',')
    //   : null;
    const empIds = Array.isArray(item.EmpIds)
  ? item.EmpIds.map(x => x.EmpId).join(',')
  : null;

const recommIds = Array.isArray(item.Recomm_EmpIds)
  ? item.Recomm_EmpIds.map(x => x.EmpId).join(',')
  : null;

        BranchData.push({
          BranchId: item.BranchId,
          EmpIds: empIds,
          Recomm_EmpIds: recommIds
        });

      });
      console.log("BranchData", BranchData);
    let saveData = {
      CurrentPolicy: {
        Policy: this.Policy,
        LoginUserId: this.data.userId,
      },
      Product: productData,
      Amount: amountData,
      Branch: BranchData,
    };
    console.log("saveData", saveData);
    this.RequestModel.JSON = JSON.stringify(saveData);
    this._MasterService
      .LOS_SaveCreditAssignmentPolicy(this.RequestModel)
      .subscribe((response) => {
        if (response[0].CODE == 0) {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: response[0].MSG,
            ...this.configSuccess,
          });
          this.getcreditAssignmentpolicy(false);
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: response[0].MSG,
            ...this.configSuccess,
          });
        }
      });
  }
}
